import { IRealtimeMessagePayload, RealtimeDataConsumer } from 'libs/realtime';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { FirebaseMessaging } from '@app/src/app/firebase/messaging';

export class FirebaseMessagingRealtimeDataConsumer extends RealtimeDataConsumer {
  readonly messageNotice$: Observable<IRealtimeMessagePayload>;

  constructor(messaging: FirebaseMessaging) {
    super();
    this.messageNotice$ = messaging.messageReceived$.pipe(
      map(msg => msg.data?.rtm),
      filter(rtmData => typeof rtmData !== 'undefined'),
      map(rtmData => JSON.parse(rtmData) as IRealtimeMessagePayload),
    );
  }
}
